import { render, staticRenderFns } from "./leaderBoard.vue?vue&type=template&id=63802688&scoped=true"
import script from "./leaderBoard.vue?vue&type=script&lang=js"
export * from "./leaderBoard.vue?vue&type=script&lang=js"
import style0 from "./leaderBoard.vue?vue&type=style&index=0&id=63802688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63802688",
  null
  
)

export default component.exports